import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import Introduction from "../../components/Introduction";
import ContactCard from "./ContactCard";
import useFetch from "../../hooks/useFetch";
import config from "../../config";
import DefaultPage from "../DefaultPage/DefaultPage";
import SchoolCard from "./SchoolCard";
import "./ContactPage.css";
import Loader from "../../components/Loader";

const ContactPage = () => {
  // fetch dat - populate pro získání atributů z bloku kontaktu (contactDetail) a populate pro získání jmen z relace (contacts)
  const { loading, error, data } = useFetch(
    `${config.api}/api/contact-page?populate[contactDetail][populate]=*&populate[contacts][populate]=*&populate[background][populate]=*`
  );

  // možné stavy při/po fetchi
  if (loading) return <Loader />;
  if (error) return <DefaultPage message="Chyba při načítání kontaktů" />;

  if (!data || !data.data) return <DefaultPage message="Žádní zaměstnanci" />;

  //? test na data z fetche
  //? console.log(data.data);

  //změna titulku stránky v prohlížeči
  document.title = data.data.title;

  return (
    <div>
      <Navbar />
      <Introduction
        title={data.data.title}
        text={data.data.description}
        image={data.data.background.url}
      />
      <div className="container-fluid background-white">
        <div className="container container-background">
          <div className="row d-flex justify-content-center">
            {/* neni potreba if na mapovani, protože response hazi kdyztak array{0} a ne null */}
            {data.data.contacts.map((contact) =>
              //prettier-ignore
              <div key={contact.id} className="col-10 col-md-6 col-lg-6 col-xl-4 p-2 p-lg-3">
              <ContactCard
                //prettier-ignore
                image={contact?.photo?.url ? `${config.api}${contact.photo.url}` : ""}
                prefix={contact?.prefix ?? ""}
                firstName={contact.firstname}
                lastName={contact.lastname}
                suffix={contact?.suffix ?? ""}
                phone={contact.phone}
                second_phone={contact.second_phone}
                email={contact.email}
                position={contact.position}
                room={contact.room}
                departments={
                  contact?.departments ?? []
                }
              />
            </div>
            )}
          </div>
          <div className="row d-flex justify-content-center pt-5">
            <SchoolCard
              //prettier-ignore
              image={`${config.api}${data.data.contactDetail.schoolPhoto.url}`}
              schoolName={data.data.contactDetail.schoolName}
              address_first_line={data.data.contactDetail.address_first_line}
              address_second_line={data.data.contactDetail.address_second_line}
              bankAccount={data.data.contactDetail.bankAccount}
              dataBox={data.data.contactDetail.dataBox}
              emailroom={data.data.contactDetail.eMailroom}
              dic={data.data.contactDetail.dic}
              email={data.data.contactDetail.email}
              ic={data.data.contactDetail.ico}
              facebook={data.data.contactDetail.facebook}
              phone={data.data.contactDetail.phone}
              founder={data.data.contactDetail.founder}
              openingHours={data.data.contactDetail.openingHours}
            />
          </div>
        </div>
        <div className="section-divider"></div>
        <div className="container-fluid background-color pt-5 pb-5">
          <div className="container">
            <h2 className="text-center">Zde nás najdete</h2>
            <iframe
              className="contact-map"
              title="skola"
              src={data.data.contactDetail.map}
              width="100%"
              height="600"
              frameBorder="0"
              sandbox="allow-scripts"
            ></iframe>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};
export default ContactPage;
